/*
 * Initial AU – collection filters, sorting and "load more" (markup: snippets/iau-facets.liquid).
 *
 * Shopify does the filtering, counting and sorting; this script only asks for the updated section
 * (Section Rendering API) and swaps the parts that changed.
 * - Desktop: each change applies straight away; the open panel stays open so several values can be picked.
 * - Phones/tablets: choices in the "Filter & sort" panel are previewed (live product count) and applied
 *   with the "Show N products" button. Closing the panel without applying puts the choices back.
 * - The address bar always reflects the current filters and sort, so links, refresh and Back work.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-iau-coll]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var mobile = window.matchMedia('(max-width: 991px)');
  var controller = null;
  var preview = null;      // { search, doc } while the phone panel is open
  var snapshot = null;     // the panel's state when it was opened
  var loadingMore = false;

  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
  function form() { return $('[data-iau-form]'); }

  /* ---------- Build the query from the form (duplicates removed, empty prices skipped) ---------- */
  function query(f) {
    var p = new URLSearchParams();
    var seen = {};
    $$('input', f).forEach(function (i) {
      if (!i.name || i.disabled) return;
      // Category: a group's product types go with the query only while its tick box (Sneakers / Apparel) is ticked.
      if (i.hasAttribute('data-iau-cat')) {
        var box = f.querySelector('[data-iau-cat-box="' + i.getAttribute('data-iau-cat') + '"]');
        if (!box || !box.checked) return;
      }
      if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
      if (i.type !== 'checkbox' && i.type !== 'radio' && String(i.value).trim() === '') return;
      var k = i.name + '\u0000' + i.value;
      if (seen[k]) return;
      seen[k] = 1;
      p.append(i.name, i.value);
    });
    return p.toString();
  }

  function sectionUrl(search) {
    return window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + (search ? '&' + search : '');
  }

  function load(search) {
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    return fetch(sectionUrl(search), { signal: controller && controller.signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  /* ---------- Swap the updated parts into the page ---------- */
  function swap(doc, keepOpen) {
    var fresh = doc.querySelector('[data-iau-coll]');
    if (!fresh) return;
    var openId = null;
    var focusKey = null;
    if (keepOpen) {
      var open = $('[data-iau-fg][open]');
      openId = open && open.id;
      var a = document.activeElement;
      if (a && root.contains(a)) focusKey = a.id ? '#' + a.id : (a.name ? a.name + '\u0000' + a.value : null);
    }
    ['[data-iau-bar]', '[data-iau-results]', '[data-iau-more]'].forEach(function (sel) {
      var cur = $(sel);
      var next = fresh.querySelector(sel);
      if (cur && next) cur.replaceWith(next);
    });
    if (openId) {
      var again = document.getElementById(openId);
      if (again) again.open = true;
    }
    if (focusKey) {
      var target = focusKey.charAt(0) === '#' ? document.getElementById(focusKey.slice(1)) :
        $$('[data-iau-input]').filter(function (i) { return i.name + '\u0000' + i.value === focusKey; })[0];
      if (target && target.focus) target.focus({ preventScroll: true });
    }
    reinitCards($('[data-iau-results]'));
    bindMore();
  }

  // Let the theme wire up what it normally does for product cards (images, hover video, quick view…).
  function reinitCards(scope) {
    if (!scope) return;
    ['btyAnimationImageLoad', 'btyHoverMediaVideo', 'btyQuickView', 'btyQuickAdd', 'btySwatch', 'btyAddToCart'].forEach(function (fn) {
      if (typeof window[fn] === 'function') {
        try { window[fn](scope); } catch (err) { /* one helper failing must not stop the rest */ }
      }
    });
    document.dispatchEvent(new CustomEvent('product-card-updated'));
  }

  function setBusy(on) {
    root.classList.toggle('is-loading', !!on);
    root.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* Apply a query: fetch, swap, update the address bar */
  function apply(search, opts) {
    opts = opts || {};
    setBusy(true);
    var done = function (doc) {
      swap(doc, opts.keepOpen);
      if (opts.push !== false) {
        var url = window.location.pathname + (search ? '?' + search : '');
        window.history.pushState({ iau: true }, '', url);
      }
      setBusy(false);
      if (opts.scroll) {
        var top = root.getBoundingClientRect().top + window.scrollY - 90;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    };
    if (opts.doc) { done(opts.doc); return Promise.resolve(); }
    return load(search).then(done).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      setBusy(false);
      window.location.href = window.location.pathname + (search ? '?' + search : ''); // fall back to a normal page load
    });
  }

  /* ---------- Phone panel: preview counts, apply, restore on close ---------- */
  function sheet() { return $('[data-iau-sheet]'); }

  function takeSnapshot() {
    snapshot = $$('[data-iau-input]', form()).map(function (i) {
      return { el: i, checked: i.checked, value: i.value };
    });
  }
  function restoreSnapshot() {
    if (!snapshot) return;
    snapshot.forEach(function (s) {
      if (!document.contains(s.el)) return;
      s.el.checked = s.checked;
      if (s.el.type === 'number') s.el.value = s.value;
    });
    snapshot = null;
  }

  function openSheet() {
    var s = sheet();
    if (!s) return;
    takeSnapshot();
    preview = null;
    s.setAttribute('role', 'dialog');
    s.setAttribute('aria-modal', 'true');
    s.setAttribute('aria-labelledby', s.getAttribute('data-labelledby'));
    s.classList.add('is-open');
    document.documentElement.classList.add('iau-sheet-open');
    var opener = $('[data-iau-sheet-open]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    // On phones every section starts open except long lists, so choices are one tap away.
    $$('[data-iau-fg]', s).forEach(function (d) {
      d.open = d.classList.contains('iau-fg--type') || d.classList.contains('iau-fg--brand') || d.classList.contains('iau-fg--size') || d.querySelector('input:checked:not([data-iau-sort])') !== null;
    });
    var close = $('[data-iau-sheet-close]', s);
    if (close) close.focus({ preventScroll: true });
  }

  function closeSheet(applied) {
    var s = sheet();
    if (!s) return;
    if (!applied) restoreSnapshot();
    s.classList.remove('is-open');
    s.removeAttribute('role');
    s.removeAttribute('aria-modal');
    s.removeAttribute('aria-labelledby');
    document.documentElement.classList.remove('iau-sheet-open');
    var opener = $('[data-iau-sheet-open]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus({ preventScroll: true });
    }
  }

  var previewTimer = null;
  function previewCounts() {
    clearTimeout(previewTimer);
    previewTimer = setTimeout(function () {
      var search = query(form());
      var applyBtn = $('[data-iau-apply]');
      if (applyBtn) applyBtn.classList.add('is-busy');
      load(search).then(function (doc) {
        preview = { search: search, doc: doc };
        var fresh = doc.querySelector('[data-iau-coll]');
        if (!fresh) return;
        // Update counts and disabled states in place, so the panel keeps its scroll and open sections.
        var freshInputs = {};
        fresh.querySelectorAll('[data-iau-input]').forEach(function (i) { freshInputs[i.name + '\u0000' + i.value] = i; });
        $$('[data-iau-input]', form()).forEach(function (i) {
          if (i.type === 'number' || i.type === 'radio') return;
          var f = freshInputs[i.name + '\u0000' + i.value];
          if (!f) return;
          var off = f.disabled && !i.checked;
          i.disabled = off;
          var lab = i.closest('label');
          if (lab) lab.classList.toggle('is-off', off);
          var count = lab && lab.querySelector('.iau-opt-count');
          var fCount = f.closest('label') && f.closest('label').querySelector('.iau-opt-count');
          if (count && fCount) count.textContent = fCount.textContent;
        });
        var nextBtn = fresh.querySelector('[data-iau-apply]');
        if (applyBtn && nextBtn) applyBtn.textContent = nextBtn.textContent;
      }).catch(function () { /* the apply button still works */ }).then(function () {
        if (applyBtn) applyBtn.classList.remove('is-busy');
      });
    }, 160);
  }

  /* ---------- Events ---------- */
  function syncTwins(input) {
    if (input.type !== 'checkbox') return;
    $$('[data-iau-input]', form()).forEach(function (other) {
      if (other !== input && other.name === input.name && other.value === input.value) other.checked = input.checked;
    });
  }

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-iau-input]');
    if (!input) return;
    syncTwins(input);

    // Picking a size also turns on "in stock", so a size that exists only as sold-out pairs isn't offered as buyable.
    if (input.hasAttribute('data-iau-size') && input.checked) {
      var stock = $('[data-iau-instock]', form());
      if (stock && !stock.checked && !root.dataset.iauStockTouched) {
        stock.checked = true;
        syncTwins(stock);
      }
    }
    if (input.hasAttribute('data-iau-instock')) root.dataset.iauStockTouched = '1';

    if (input.hasAttribute('data-iau-price')) {
      if (mobile.matches && sheet() && sheet().classList.contains('is-open')) previewCounts();
      return; // desktop prices apply with their button or Enter
    }

    if (mobile.matches && sheet() && sheet().classList.contains('is-open')) {
      previewCounts();
      return;
    }

    var isSort = input.hasAttribute('data-iau-sort');
    if (isSort) {
      var d = input.closest('details');
      if (d) d.open = false;
    }
    apply(query(form()), { keepOpen: !isSort });
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-iau-sheet-open]')) { e.preventDefault(); openSheet(); return; }
    if (e.target.closest('[data-iau-sheet-close]')) { e.preventDefault(); closeSheet(false); return; }

    if (e.target.closest('[data-iau-apply]')) {
      e.preventDefault();
      var search = query(form());
      var usable = preview && preview.search === search ? preview.doc : null;
      closeSheet(true);
      apply(search, { doc: usable, scroll: true });
      return;
    }

    if (e.target.closest('[data-iau-clear]') && mobile.matches && sheet() && sheet().classList.contains('is-open')) {
      e.preventDefault();
      $$('[data-iau-input]', form()).forEach(function (i) {
        if (i.type === 'checkbox') i.checked = false;
        if (i.type === 'number') i.value = '';
      });
      previewCounts();
      return;
    }

    var priceBtn = e.target.closest('[data-iau-price-apply]');
    if (priceBtn) {
      e.preventDefault();
      if (mobile.matches && sheet() && sheet().classList.contains('is-open')) { previewCounts(); return; }
      apply(query(form()), { keepOpen: false });
      var pd = priceBtn.closest('details');
      if (pd) pd.open = false;
      return;
    }

    // Removing a Sneakers / Apparel chip unticks that group and applies.
    var catClear = e.target.closest('[data-iau-cat-clear]');
    if (catClear) {
      e.preventDefault();
      var catBox = $('[data-iau-cat-box="' + catClear.getAttribute('data-iau-cat-clear') + '"]', form());
      if (catBox) catBox.checked = false;
      apply(query(form()), { scroll: false });
      return;
    }

    var link = e.target.closest('[data-iau-link], [data-iau-clear]');
    if (link && link.href) {
      e.preventDefault();
      var url = new URL(link.href, window.location.origin);
      apply(url.search.slice(1), { scroll: false });
      return;
    }

    var next = e.target.closest('[data-iau-next]');
    if (next) { e.preventDefault(); loadMore(next); }
  });

  // Enter in a price box applies on desktop instead of submitting the whole page.
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-iau-price]')) {
      e.preventDefault();
      if (mobile.matches && sheet() && sheet().classList.contains('is-open')) previewCounts();
      else apply(query(form()), { keepOpen: false });
    }
    if (e.key === 'Tab' && sheet() && sheet().classList.contains('is-open')) {
      var f = $$('a[href], button:not([disabled]), input:not([disabled]), summary', sheet()).filter(function (el) { return el.getClientRects().length > 0; });
      if (f.length) {
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (e.key === 'Escape') {
      if (sheet() && sheet().classList.contains('is-open')) { closeSheet(false); return; }
      var open = $('[data-iau-fg][open]');
      if (open && !mobile.matches) {
        open.open = false;
        var sum = open.querySelector('summary');
        if (sum) sum.focus();
      }
    }
  });

  // Desktop panels behave like drop-downs: one open at a time, closed by clicking elsewhere.
  root.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-iau-fg]') || !d.open || mobile.matches) return;
    $$('[data-iau-fg][open]').forEach(function (o) { if (o !== d) o.open = false; });
    // Keep the panel inside the viewport.
    var panel = d.querySelector('.iau-fg-panel');
    if (panel) {
      panel.classList.remove('is-flipped');
      var r = panel.getBoundingClientRect();
      if (r.right > window.innerWidth - 12) panel.classList.add('is-flipped');
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (mobile.matches) return;
    if (e.target.closest('[data-iau-fg]')) return;
    $$('[data-iau-fg][open]').forEach(function (o) { o.open = false; });
  });

  // The form never submits the page itself.
  root.addEventListener('submit', function (e) { e.preventDefault(); });

  window.addEventListener('popstate', function () {
    apply(window.location.search.slice(1), { push: false });
  });

  /* ---------- Load more / infinite scroll ---------- */
  var moreObserver = null;
  function loadMore(btn) {
    if (loadingMore) return;
    loadingMore = true;
    btn.classList.add('is-busy');
    var url = new URL(btn.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    fetch(url.pathname + url.search, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-iau-results] .products');
        var cards = doc.querySelectorAll('[data-iau-results] .products > *');
        var frag = document.createDocumentFragment();
        cards.forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
        if (grid) {
          var firstNew = frag.firstElementChild;
          grid.appendChild(frag);
          reinitCards(grid);
          if (firstNew && document.activeElement === btn) {
            var a = firstNew.querySelector('a[href]');
            if (a) a.focus({ preventScroll: true });
          }
        }
        var cur = $('[data-iau-more]');
        var nextMore = doc.querySelector('[data-iau-more]');
        if (cur && nextMore) cur.replaceWith(nextMore);
        loadingMore = false;
        bindMore();
      })
      .catch(function () {
        loadingMore = false;
        window.location.href = btn.href;
      });
  }

  function bindMore() {
    if (moreObserver) { moreObserver.disconnect(); moreObserver = null; }
    if (root.getAttribute('data-infinite') !== 'true' || !('IntersectionObserver' in window)) return;
    var btn = $('[data-iau-next]');
    if (!btn) return;
    moreObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) loadMore(btn); });
    }, { rootMargin: '600px 0px' });
    moreObserver.observe(btn);
  }

  bindMore();
})();
